import Head from 'next/head';
import { ThemeCard } from '@/components/themes/ThemeCard';
import { THEMES } from '@sizzlenz/shared';

export default function ThemesIndexPage() {
  return (
    <>
      <Head>
        <title>Themes | Sizzle</title>
        <meta
          name="description"
          content="Browse initiative themes and find brand partnerships tailored to your industry or occasion."
        />
      </Head>
      <div className="min-h-screen bg-white">
        {/* Hero */}
        <div className="bg-gradient-to-br from-indigo-50 via-white to-purple-50 border-b border-gray-100">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16">
            <h1 className="text-3xl sm:text-4xl font-bold text-gray-900">Themes</h1>
            <p className="mt-3 text-lg text-gray-600 max-w-2xl">
              Browse by theme to find brand partnerships and initiatives tailored to your industry,
              venue, or occasion.
            </p>
          </div>
        </div>

        {/* Categories Grid */}
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 sm:py-14">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {THEMES.map((category) => (
              <ThemeCard key={category.slug} {...category} />
            ))}
          </div>
        </div>
      </div>
    </>
  );
}
